import { render, staticRenderFns } from "./MyCom.vue?vue&type=template&id=157aaaae&scoped=true&"
import script from "./MyCom.vue?vue&type=script&lang=js&"
export * from "./MyCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157aaaae",
  null
  
)

export default component.exports